<script setup lang="ts">
import { h } from 'vue';
import { LANG_FRENCH } from '@/constants';

interface Props {
  currentLanguage: string;
  frHTMLData?: string;
  enHTMLData?: string;
}
const props = defineProps<Props>();

const renderHtml = () => {
  if (!props.frHTMLData && !props.enHTMLData) {
    return '';
  }
  return props.currentLanguage === LANG_FRENCH ? h('div', { class: 'french-term', innerHTML: props.frHTMLData }) : h('div', { class: 'english-term', innerHTML: props.enHTMLData });
};
</script>

<template>
  <div class="render-html">
    <renderHtml />
  </div>
</template>
